import Cart from "@components/Cart/Cart";
import Button from "@components/CartButtons/Buttons";
import styles from "@styles/Cart.module.scss";
import { useAppContext } from "@context/appContext";

const CartPage = () => {
  const { cart } = useAppContext();

  const totalItems = cart.reduce((total, item) => total + item.quantity, 0);
  const isCartEmpty = totalItems === 0;

  return (
    <>
      <div className={styles.cartWrapper}>
        <Cart />
      </div>
      <Button isCartEmpty={isCartEmpty} totalItems={totalItems} />
    </>
  );
};

export default CartPage;
